
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"#fff","xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 4V2.5a.5.5 0 01.5-.5h3a.5.5 0 01.5.5V4h4a1 1 0 011 1v8a1 1 0 01-1 1H2a1 1 0 01-1-1V5a1 1 0 011-1zm1.15-1a.15.15 0 00-.15.15V4h2v-.85A.15.15 0 008.85 3zM3.33 5.5a.33.33 0 00-.33.33v6.34a.33.33 0 00.33.33h.34a.33.33 0 00.33-.33V5.83a.33.33 0 00-.33-.33zm9 0a.33.33 0 00-.33.33v6.34a.33.33 0 00.33.33h.34a.33.33 0 00.33-.33V5.83a.33.33 0 00-.33-.33z"}})])
          )
        }
      }
    